import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var FolderCopy = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6H1v15h19v-2H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 4h-9l-2-2H5.01L5 17h18V4z"
  }));
});
FolderCopy.displayName = 'FolderCopy';
export var FolderCopyDimensions = {
  height: 24,
  width: 24
};